/**
 * Displays an absolutely positioned legend of the cell color descriptions.
 * Child component  PeriodicTable
 */
import React, { useContext } from "react";
import styled from "styled-components";
import { PeriodicTableContext } from "./PeriodicTableContext";

const PeriodicTableLabels = () => {
  const { selectedElements, availableWithSelectedElements } = useContext(
    PeriodicTableContext
  );

  return (
    <Labels>
      <LabelsList>
        <LabelsRow>
          <LabelsBox style={{ backgroundColor: "#cade82" }}></LabelsBox>
          <label>Available on 2DSemiconductors.com</label>
        </LabelsRow>
        {selectedElements.length > 0 && (
          <LabelsRow>
            <LabelsBox style={{ backgroundColor: "#6cbee7" }}></LabelsBox>
            <label>Selected</label>
          </LabelsRow>
        )}
        {selectedElements.length > 0 &&
          availableWithSelectedElements.length > 0 && (
            <LabelsRow>
              <LabelsBox style={{ backgroundColor: "#cbe8f7" }}></LabelsBox>
              <label>Available with selected element</label>
            </LabelsRow>
          )}
      </LabelsList>
    </Labels>
  );
};

export default PeriodicTableLabels;

const Labels = styled.div`
  text-align: center;
  position: absolute;
  left: 11.11111%;
  width: 55.55556%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    position: initial;
    width: 100vw;
    align-items: center;
    justify-content: center;
  }
`;

const LabelsList = styled.div`
  padding-top: 15px;
  width: auto;
  margin: 0 auto;
  text-align: left;
  font-weight: 400;

  @media (max-width: 768px) {
    padding-top: 0;
  }
`;

const LabelsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

const LabelsBox = styled.div`
  width: 2vh;
  height: 2vh;
  box-shadow: 0 0 1px #000;
  margin-right: 5px;
`;
